import { API } from "aws-amplify";


const index = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    const ret = await API.get("InasakuAPI", "/inasaku/weather-settings", myInit);
    return ret.data;
};

const insert = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };

    let res = await API.post("InasakuAPI", "/inasaku/weather-settings", myInit);

    return res;
};

const update = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params, // replace this with attributes you need
        },
        headers: {} // OPTIONAL
    };

    let res = await API.put("InasakuAPI", `/inasaku/weather-settings`, myInit);

    return res;
};

const del = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params, // replace this with attributes you need
        },
        headers: {} // OPTIONAL
    };

    let res = await API.del("InasakuAPI", `/inasaku/weather-settings`, myInit);

    return res;
};


export default {
    index,
    insert,
    update,
    del
};
